import React from 'react'
import styles from './Pricing.module.scss'
import { COUNTRY, currencyConfig } from '../../../../common/utils/constants'
import { usePromo, formatPromoMonth } from './usePromo'

interface PricingCard {
  id: string
  title: string
  price: string
  period: string
  features: React.ReactNode[]
  fixedText: string
  promo?: boolean
}

const isRu = COUNTRY === 'ru'
const { symbol, rate } = currencyConfig[COUNTRY] || currencyConfig.ru
const conv = (rub: number) => Math.round(rub / rate)

const FEATURES: React.ReactNode[] = [
  'Сайт-витрина под ключ',
  'Мобильное приложение',
  'CRM и база клиентов',
  'Продажи онлайн и офлайн',
  'Склад и остатки',
  'Персонал и мотивация',
  ...(isRu ? ['Оплаты (СБП + карты)'] : []),
  'Бонусная система',
  'Свои курьеры + СДЭК',
  'Чат с клиентами',
  'Все обновления',
  <>
    Вакансии на{' '}
    <a
      href="https://logplace.ru"
      target="_blank"
      rel="noopener noreferrer"
      className={styles.featureLink}
    >
      Логплейс
    </a>
  </>,
  <>
    Размещение на{' '}
    <a
      href="https://logmall.ru"
      target="_blank"
      rel="noopener noreferrer"
      className={styles.featureLink}
    >
      Логмолл
    </a>
  </>,
]

export const Pricing: React.FC = () => {
  const promo = usePromo()

  const PRICING_DATA: PricingCard[] = [
    {
      id: 'club',
      title: 'Клуб / соцпроект',
      price: `${conv(1000).toLocaleString()} ${symbol}`,
      period: '/мес',
      features: FEATURES,
      fixedText: `Выручка до ${conv(200000).toLocaleString()} ${symbol}/мес`,
    },
    {
      id: 'startup',
      title: 'Стартап',
      price: `${conv(1000).toLocaleString()} ${symbol}`,
      period: '/мес',
      features: FEATURES,
      fixedText: `Первые 6 месяцев или до ${conv(200000).toLocaleString()} ${symbol}/мес`,
    },
    {
      id: 'local',
      title: 'Локальный бизнес',
      price: `${conv(10000).toLocaleString()} ${symbol}`,
      period: '/мес',
      features: FEATURES,
      promo: true,
      fixedText: promo.isPromo
        ? `При запуске до конца ${formatPromoMonth(promo.promoEnd!)}`
        : 'Цена фиксируется на год',
    },
    {
      id: 'network',
      title: 'Сеть',
      price: `до ${conv(3000).toLocaleString()} ${symbol}`,
      period: '/точка',
      features: FEATURES,
      fixedText: 'Цена фиксируется на год',
    },
  ]

  return (
    <div className={styles.container}>
      {PRICING_DATA.map((card) => {
        const isPromoCard = promo.isPromo && card.promo

        return (
          <div key={card.id} className={styles.card}>
            <h3 className={styles.title}>{card.title}</h3>
            <div className={styles.price}>
              {isPromoCard ? (
                <span className={styles.promoWrap}>
                  <span className={styles.promoBg}>
                    {conv(10000).toLocaleString()} {symbol}
                  </span>
                  <span className={styles.valueRow}>
                    <span className={styles.value}>
                      {conv(5000).toLocaleString()} {symbol}
                    </span>
                    <span className={styles.period}>{card.period}</span>
                  </span>
                </span>
              ) : (
                <span className={styles.valueRow}>
                  <span className={styles.value}>{card.price}</span>
                  <span className={styles.period}>{card.period}</span>
                </span>
              )}
            </div>
            <ul className={styles.list}>
              {card.features.map((feature, idx) => (
                <li key={idx}>{feature}</li>
              ))}
            </ul>
            <div className={styles.fixed}>{card.fixedText}</div>
          </div>
        )
      })}
    </div>
  )
}
